import styled from "../_snowpack/pkg/@emotion/styled.js";
import React, {useState} from "../_snowpack/pkg/react.js";
import {t} from "../common/i18n.js";
import {Title} from "./typo.js";
import {colors, fontFamily, lineHeight, media} from "./theme.js";
import {formatLocalDate, getTranslatedName, withAttrs} from "../common/utils.js";
import Stack from "./stack.js";
import {formatCurrency} from "../common/universal.js";
import Button from "./button.js";
import {useCartStore} from "../stores/cart.js";
import Input from "./input.js";
import {captureException} from "../_snowpack/pkg/@sentry/react.js";
import Icon from "./icon.js";
export default function CartSidebar(props) {
  const {buttons, withoutHeadline, ...rest} = props;
  const {cart, addCoupon, removeCoupon} = useCartStore();
  const {items, gross_price, net_price, taxes, discounts, coupon} = cart;
  const itemsByShipping = groupByShippingDate(items);
  return /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, /* @__PURE__ */ React.createElement(Inner, null, !withoutHeadline && /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(Headline, null, t("Bestellübersicht"))), itemsByShipping.map(({date, items: items2}) => /* @__PURE__ */ React.createElement(Items, {
    key: date,
    date,
    items: items2,
    discounts
  })), discounts ? /* @__PURE__ */ React.createElement(TotalDiscounts, {
    ...discounts,
    removeCoupon,
    couponId: coupon?.id
  }) : /* @__PURE__ */ React.createElement(CouponField, {
    cart,
    addCoupon
  }), /* @__PURE__ */ React.createElement(PriceSection, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(OverallPriceLabel, null, t("Gesamtpreis (Netto)")), /* @__PURE__ */ React.createElement(OverallPriceValue, null, formatCurrency(net_price))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PriceLabel, null, t("Gesamtpreis (Brutto)")), /* @__PURE__ */ React.createElement(PriceValue, null, formatCurrency(gross_price))), taxes.map((tax) => /* @__PURE__ */ React.createElement(Row, {
    key: tax.tax_rate
  }, /* @__PURE__ */ React.createElement(PriceLabel, null, t("USt."), " ", tax.tax_rate, " %"), /* @__PURE__ */ React.createElement(PriceValue, null, formatCurrency(tax.price)))))), buttons && /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(Buttons, null, buttons)));
}
function TotalDiscounts(props) {
  const {type, discounts, removeCoupon, couponId} = props;
  if (type !== "total")
    return null;
  return /* @__PURE__ */ React.createElement(TotalDiscountsSection, null, discounts.map((d, i) => /* @__PURE__ */ React.createElement(Discount, {
    key: i,
    ...d
  })), couponId && /* @__PURE__ */ React.createElement(CouponButton, {
    onClick: () => removeCoupon(couponId),
    secondary: true
  }, /* @__PURE__ */ React.createElement(Icon, {
    name: "bin"
  }), t("Entfernen")));
}
function Discount(props) {
  const {target, discountType, discountValue, valueNet} = props;
  const isFree = discountType === "free";
  const isPercent = discountType === "percent";
  let label = "";
  if (target === "shipping") {
    label = isFree ? t("Versandkostenfrei") : t("Versandkostenrabatt");
  }
  if (target === "total") {
    label = t("Rabatt");
  }
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Label, null, "🏷️ ", label, isPercent ? ` (${discountValue}%)` : ""), /* @__PURE__ */ React.createElement(Value, null, "-", formatCurrency(valueNet)));
}
function CouponField(props) {
  const {addCoupon} = props;
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(void 0);
  const onChange = (e) => {
    setError(void 0);
    setCode(e.target.value);
  };
  const onClick = async () => {
    setLoading(true);
    try {
      await addCoupon(code);
    } catch (e) {
      captureException(e);
      setError(e);
    } finally {
      setLoading(false);
    }
  };
  const disabled = !!error || !code || code.length !== 6;
  return /* @__PURE__ */ React.createElement(CouponSection, null, /* @__PURE__ */ React.createElement(CouponSectionInner, null, /* @__PURE__ */ React.createElement(CouponInput, {
    name: "code",
    onChange,
    placeholder: t("Couponcode eingeben"),
    invalid: !!error
  }), /* @__PURE__ */ React.createElement(CouponButton, {
    disabled,
    onClick,
    loading
  }, t("Einlösen"))), error && /* @__PURE__ */ React.createElement(CouponError, null, error.message));
}
function Items(props) {
  const {date, items, discounts} = props;
  const items_count = items.length;
  const totalCount = items_count + items.reduce((acc, i) => acc + (i.option_articles?.length || 0), 0);
  const itemsDiscounts = discounts?.type === "position" ? discounts.discounts : [];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(ItemHeader, null, totalCount, " ", t("Artikel"), ", ", t("Liefertermin"), " ", date)), /* @__PURE__ */ React.createElement(SlimSection, null, items.map((i) => /* @__PURE__ */ React.createElement(Item, {
    key: i.id,
    ...i,
    discounts: itemsDiscounts.filter((d) => d.itemId === i.id)
  }))));
}
function Item(props) {
  const {
    name,
    article,
    product_page,
    option_articles,
    shipping_config,
    shipping_net_price,
    discounts
  } = props;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Label, null, product_page ? getTranslatedName(product_page) : name), /* @__PURE__ */ React.createElement(Value, null, /* @__PURE__ */ React.createElement("div", null, formatCurrency(article.net_price)), /* @__PURE__ */ React.createElement("small", null, formatCurrency(article.unit_price), " / ", t("Stk")))), option_articles && option_articles.map((o) => /* @__PURE__ */ React.createElement(Row, {
    key: o.id
  }, /* @__PURE__ */ React.createElement(Label, null, o.option.name), /* @__PURE__ */ React.createElement(Value, null, formatCurrency(o.net_price)))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Label, null, shipping_config ? getShippingText(shipping_config) : t("📦 Standardversand DE")), /* @__PURE__ */ React.createElement(Value, null, formatCurrency(shipping_net_price))), discounts.length > 0 && discounts.map((d, i) => /* @__PURE__ */ React.createElement(Discount, {
    key: i,
    ...d
  })));
}
function getShippingText(config) {
  const {carrier} = config;
  if (carrier === "DHL") {
    return t("📦 Standardversand");
  }
  if (carrier === "Krage") {
    return t("🚚 Versand per Spedition");
  }
  return t("🎉 Kostenloser Versand");
}
function groupByShippingDate(items) {
  const keyedItems = items.reduce((acc, item) => {
    const {plannedDeliveryDate} = item.article;
    const formatted_date = plannedDeliveryDate ? formatLocalDate(plannedDeliveryDate) : "";
    const prev = acc[formatted_date] || [];
    return Object.assign(acc, {[formatted_date]: [...prev, item]});
  }, {});
  return Object.entries(keyedItems).map(([date, items2]) => ({date, items: items2}));
}
const Container = styled.div`
  margin-top: 16px;
`;
const Headline = styled(withAttrs(Title, {level: 2}))`
  font-size: 30px;
`;
const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: 1px solid ${colors.b6};
  border-bottom: 1px solid ${colors.b6};

  &:first-of-type {
    border-top: none;
  }

  &:last-of-type {
    border-bottom: none;
  }

  ${media.mobile} {
    border: none;
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;
const SlimSection = styled(Section)`
  gap: 7px;
`;
const Label = styled.div`
  font-family: ${fontFamily.secondary};
  font-size: 14px;
  font-weight: 500;
  line-height: ${lineHeight};
`;
const Value = styled.div`
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  text-align: right;
  font-weight: 600;

  small {
    font-size: 12px;
    color: ${colors.b4};
    font-weight: 400;
  }
`;
const ItemHeader = styled.div`
  font-family: ${fontFamily.secondary};
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  text-transform: uppercase;
`;
const PriceSection = styled(Section)`
  border-top-color: ${colors.b};
`;
const OverallPriceLabel = styled(Label)`
  font-weight: 700;
  text-transform: uppercase;
`;
const OverallPriceValue = styled.div`
  font-family: ${fontFamily.secondary};
  font-size: 24px;
  font-weight: 700;
  line-height: ${lineHeight};
`;
const PriceLabel = styled.div`
  font-family: ${fontFamily.primary};
  font-weight: 400;
  font-size: 14px;
  line-height: ${lineHeight};
`;
const PriceValue = styled(PriceLabel)``;
const Buttons = styled(Stack)``;
const Inner = styled.div`
  ${media.mobile} {
    display: none;
  }
`;
const CouponSection = styled(Section)`
  gap: 4px;
`;
const CouponSectionInner = styled.div`
  display: flex;
  gap: 10px;
`;
const CouponError = styled.div`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  line-height: ${lineHeight};
  color: ${colors.r6};
`;
const CouponInput = styled(withAttrs(Input, {type: "text", maxLength: 6}))`
  text-transform: uppercase;

  &::placeholder {
    text-transform: none;
  }
`;
const CouponButton = styled(withAttrs(Button, {small: true}))``;
const TotalDiscountsSection = styled(Section)``;
